import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/account/favoriteItemPrice.scss';
import marketplace from 'cfg/marketplace.json';

const { features: { showOOSNotifyMe } } = marketplace;

const calculatePercentOff = (listPrice, price) => (listPrice && price ? Math.round((1 - price / listPrice) * 100) : 0);

const FavoriteItemPrice = ({ item, oosHearts = [], showOOSNotifyMe }, { testId }) => {
  const {
    quantity,
    price,
    size,
    listPrice
  } = item;

  const percentOff = calculatePercentOff(listPrice, price);
  const lowStock = quantity > 0 && quantity <= 4;
  const isItemOos = oosHearts.includes(item.itemId);

  if (quantity) {
    return (
      <div className={css.container}>
        <div className={ cn(css.price, { [css.salePrice] : percentOff }) } data-test-id={testId('price')}>{toUSD(price)}</div>
        {percentOff ? <div className={css.msrp} data-test-id={testId('msrp')}>MSRP: {toUSD(listPrice)}</div> : null}
        {percentOff ? <div className={css.percentOff} data-test-id={testId('percentOff')}>{percentOff}% OFF</div> : null}
        {/* checking for size because that means its a favorite */}
        {lowStock && size ? <div className={css.lowStock} data-test-id={testId('lowStock')}>{quantity} LEFT</div> : null}
      </div>
    );
  } else if (showOOSNotifyMe && isItemOos) {
    return (
      <div className={cn(css.container, css.oos)}>
        <div>Out of stock</div>
        <div className={css.verbiage} data-test-id={testId('oosNotifyMe')}>
          We're sorry! This item is out of stock
        </div>
      </div>
    );
  } else {
    return (
      <div className={cn(css.container, css.oos)}>
        <div data-test-id={testId('unavailable')}>Unavailable</div>
        {
          showOOSNotifyMe
          && <div className={css.verbiage} data-test-id={testId('oosNotifyRequest')}>
            This item has become unavailable. Would you like to be notified through email when we get more in stock?
          </div>
        }
      </div>
    );
  }
};

FavoriteItemPrice.contextTypes = {
  testId: PropTypes.func
};

FavoriteItemPrice.propTypes = {
  item: PropTypes.object.isRequired
};

FavoriteItemPrice.defaultProps = {
  showOOSNotifyMe
};

export default FavoriteItemPrice;
